import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { EmptyState } from "@/components/app/lists/empty-state";
import { PageHeader } from "@/components/app/shell/page-header";
import { ReadFailed } from "@/components/app/lists/read-failed";
import { Skeleton } from "@/components/ui/skeleton";
import { orpc } from "@/lib/orpc";
import { MyCourses } from "@/routes/_authenticated/_workforce/training/-components/my-courses";

export const Route = createFileRoute("/_authenticated/_workforce/training/")({
  component: Training,
});

/* My own courses; the building's numbers are on Overview and Who owes training. */
function Training() {
  const mine = useQuery(orpc.workforce.training.myTraining.queryOptions({}));

  /* Open work first and finished below it, because the list is read to answer
     "what do I still owe" far more often than "what have I done". */
  const open = (mine.data ?? []).filter((row) => row.state !== "completed");
  const done = (mine.data ?? []).filter((row) => row.state === "completed");
  const overdue = open.filter((row) => row.state === "overdue").length;

  return (
    <>
      <PageHeader
        title="My training"
        count={mine.data ? mine.data.length : undefined}
        meta={
          mine.data
            ? mine.data.length === 0
              ? "Courses you are assigned appear here."
              : open.length === 0
                ? "You are all caught up."
                : `${open.length} to complete${overdue ? `, ${overdue} overdue` : ""}`
            : "What you have been assigned."
        }
      />

      {mine.isPending ? (
        <Skeleton className="h-64 w-full" />
      ) : mine.isError ? (
        <ReadFailed
          message="Could not load your training. Nothing here means nothing was read, not that nothing is due."
          error={mine.error}
          onRetry={() => void mine.refetch()}
          retrying={mine.isFetching}
        />
      ) : mine.data.length === 0 ? (
        <EmptyState
          title="Nothing assigned"
          description="When a course is assigned to you, it appears here with its due date."
        />
      ) : (
        <div className="space-y-6">
          <MyCourses heading="To complete" rows={open} empty="You are up to date." />
          {done.length > 0 ? <MyCourses heading="Finished" rows={done} empty="" /> : null}
        </div>
      )}
    </>
  );
}
